const styles = theme => ({
  content: {
    backgroundColor: theme.palette.background.default,
    width: '100%',
    height:'100%',
    marginTop: 70,
    marginLeft: 24,
    marginRight: 24,
    marginBottom: 24,
    paddingLeft:0,
    paddingTop:16,
    [theme.breakpoints.up('sm')]: {
      height: 'calc(100% - 64px)',
      marginTop: 70,
      marginLeft: 24,
      marginRight: 24,
      paddingTop: 16,
    },
    [theme.breakpoints.up('md')]: {
      paddingTop:16,
      height: 'calc(100% - 64px)',
      marginTop: 70,
      marginLeft: 24,
      marginRight: 24,
      width: 'calc(100%)',
    },
  },
  card: {
   minWidth: 100,
   maxWidth: 500,
   [theme.breakpoints.up('sm')]: {
     marginLeft: 'calc( (100% - 500px) * 0.5)',
   },
   [theme.breakpoints.up('md')]: {
     marginLeft: 'calc( (100% - 500px) * 0.5)',
   },
 },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Login/components/CoreContent/styles.js